import React, { useMemo } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { getArrayFromTree, getParents } from "./tree.helper";
import { AutoComplete, AutoCompleteOption } from "../AutoComplete";
import { MenuTreeItem } from "./types";
import { styled } from "@mui/material";

interface MenuSearchProps {
  data: MenuTreeItem[];
  onSelectItem: (openedItens: string[], newTreeData: MenuTreeItem[]) => void;
  placeHolderText?: string;
  maxSearchResults?: number;
}

const MenuSearch: React.FC<MenuSearchProps> = ({
  data,
  onSelectItem,
  placeHolderText,
  maxSearchResults,
}) => {
  const allOptions = useMemo(() => getArrayFromTree(data), [data]);

  const onSearchSelect = (selectedItem?: AutoCompleteOption) => {
    if (selectedItem) {
      const { parentsItems, parentsIds } = getParents(data, selectedItem.id);
      onSelectItem([...parentsIds, selectedItem.id], parentsItems);
    } else {
      onSelectItem([], data);
    }
  };

  return (
    <Search
      onSelect={onSearchSelect}
      options={allOptions}
      icon={<SearchIcon />}
      placeHolder={placeHolderText ?? "Search"}
      maxResults={maxSearchResults}
      className="menu-tree-search"
    />
  );
};

export default MenuSearch;
const Search = styled(AutoComplete)(({ theme }) => ({
  margin: "0.75rem 1.5rem",
  width: "75%",
  svg: {
    fill: theme.tokens.colors.gray[6],
  },

  "&:hover": {
    svg: { fill: theme.tokens.colors.gray[7] },
  },
}));
